module.exports = __webpack_public_path__ + "img/bus.597738a7.png";